import type {Feature, FeatureCollection, Point} from 'geojson';
import type {ForestMassSpecies} from '@/domain/entities/ForestMassSpecies';
import type {InventoryPlot} from '@/domain/entities/InventoryPlot';

export type InventoryPlotMapFeatureProps = {
  uuid: string;
  code: string;
  diameter: number;
  speciesUuid?: string;
};

export type InventoryPlotMapFeature = Feature<Point, InventoryPlotMapFeatureProps>;

export type InventoryPlotMapFeatureCollection = FeatureCollection<
  Point,
  {
    uuid: string;
    code: string;
    diameter: number;
    speciesUuid?: string;
  }
>;

export const getGeoJsonFromInventoryPlots = (
  inventoryPlots: Array<InventoryPlot>,
  forestMassSpecies: Array<ForestMassSpecies>,
): InventoryPlotMapFeatureCollection => {
  return {
    type: 'FeatureCollection',
    features: inventoryPlots.map((inventoryPlot) => ({
      type: 'Feature',
      geometry: inventoryPlot.position,
      properties: {
        uuid: inventoryPlot.uuid,
        code: inventoryPlot.code,
        diameter: inventoryPlot.diameter,
        speciesUuid: forestMassSpecies.find((fms) => fms.uuid === inventoryPlot.forestMassSpeciesUuid)?.speciesUuid,
      },
    })),
  };
};
